"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.THREE_STEP_COLUMN_STYLE = exports.FOUR_STEP_COLUMN_STYLE = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _StepComponentPropTypes = _interopRequireDefault(require("./StepComponentPropTypes"));
var THREE_STEP_COLUMN_STYLE = exports.THREE_STEP_COLUMN_STYLE = 'col-md-4 col-sm-4 col-xs-12';
var FOUR_STEP_COLUMN_STYLE = exports.FOUR_STEP_COLUMN_STYLE = 'col-md-3 col-sm-6 col-xs-6';
var stepsLimit = 4;
var buildStepLabels = function buildStepLabels(stepLabels) {
  var steps = [];
  for (var i = 0; i < stepLabels.length; i += 1) {
    if (i >= stepsLimit) {
      break;
    }
    steps.push({
      step: stepLabels[i].step,
      label: stepLabels[i].label
    });
  }
  return steps;
};
var StepComponent = function StepComponent(_ref) {
  var currentStep = _ref.currentStep,
    stepLabels = _ref.stepLabels,
    props = (0, _objectWithoutProperties2.default)(_ref, ["currentStep", "stepLabels"]);
  var steps = buildStepLabels(stepLabels);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "row",
    id: "step-container",
    "data-qa": "step-container"
  }, steps.map(function (item, i) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(currentStep === item.step ? 'active__div' : 'inactive__div', "\n         ").concat(steps.length < stepsLimit ? THREE_STEP_COLUMN_STYLE : FOUR_STEP_COLUMN_STYLE),
      key: item.label
    }, /*#__PURE__*/_react.default.createElement("h3", {
      className: "".concat(currentStep === item.step ? 'active__text' : 'inactive__text', " text-center")
    }, "".concat(props.step, " ").concat(i + 1)), /*#__PURE__*/_react.default.createElement("h3", {
      className: "".concat(currentStep === item.step ? 'active__text' : 'inactive__text', " text-center")
    }, item.label));
  }));
};
StepComponent.propTypes = _StepComponentPropTypes.default;
var _default = exports.default = StepComponent;